import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'app/store';

import { SessionStatus } from 'model/types/session';

const selectAuth = (state: RootState) => state.auth;
const selectMerchant = (state: RootState) => state.merchant.merchant;

export const selectSessionStatus = createSelector([selectAuth, selectMerchant], (auth, merchant): SessionStatus => {
  const { isLoggedIn, phase, user, userTokenInfo } = auth;

  if (phase === 'booting') return { status: 'booting' };
  if (!isLoggedIn) return { status: 'anonymous' };
  // Credentials accepted, user not loaded yet.
  if (!user) return { status: 'booting' };
  if (phase === 'attaching') return { status: 'attaching', user };

  const role = userTokenInfo?.role?.type;
  if (!role) {
    // A single-role user is attached by JWTProvider rather than asked to choose.
    return (user.roles?.length ?? 0) > 1 ? { status: 'merchant-selection', user } : { status: 'attaching', user };
  }
  if (!merchant) return { status: 'attaching', user };

  return { status: 'active', user, merchant, role };
});
